import Vue from 'vue'
import Router from 'vue-router'
import store from './store/'
import Home from './views/Home.vue'
// import i18n from '@/i18n'
// import NProgress from 'nprogress'

Vue.use(Router)

const router = new Router({
	// mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'history',
	mode: 'hash',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/yarn-count-converter',
			name: 'yarn-count-converter',
			component: () => import('./views/YarnCountConverter.vue')
		},
		{
			path: '/coming-soon',
			name: 'coming-soon',
			meta: {requiresAuth: true},
			component: () => import('./views/ComingSoon.vue')
		},
		{
			path: '/about-us',
			name: 'about-us',
			component: () => import('./views/AboutUs.vue')
		},
		{
			path: '/contacts',
			name: 'contacts',
			component: () => import('./views/Contacts.vue')
		},
		{
			path: '/settings',
			name: 'settings',
			component: () => import('./views/Settings.vue')
		},
		{
			path: '/calculations',
			name: 'calculations',
			component: () => import('./views/Calculations/Calculations.vue')
		},
		{
			path: '/calculations/calculate-twists',
			name: 'calculate-twists',
			component: () => import('./views/Calculations/CalculateTwists.vue')
		},
		{
			path: '/calculations/measure-yarn-count',
			name: 'measure-yarn-count',
			component: () => import('./views/Calculations/MeasureYarnCount.vue')
		},
		{
			path: '/calculations/needles-heads',
			name: 'needles-heads',
			component: () => import('./views/Calculations/NeedlesHeads.vue')
		},
		{
			path: '/calculations/calculate-production-kgh',
			name: 'calculate-production-kgh',
			component: () => import('./views/Calculations/CalculateProductionKgh.vue')
		},
		{
			path: '/calculations/calculate-roving-bobbins-steering',
			name: 'calculate-roving-bobbins-steering',
			component: () => import('./views/Calculations/CalculateRovingBobbinsSteering.vue')
		},
		{
			path: '/yarn-creation',
			name: 'yarn-creation',
			component: () => import('./views/YarnCreation/YarnCreation.vue'),
			props: true,
		},
		{
			path: '/yarns',
			name: 'yarns',
			component: () => import('./views/Yarns/Yarns.vue')
		},
		{
			path: '/yarns/:type/:id',
			name: 'yarn',
			component: () => import('./views/Yarns/Yarn.vue'),
		},
		{
			path: '/yarns/:type/',
			redirect: {name: 'yarns'},
		},
		{
			path: '/auth',
			component: () => import('./views/Auth/Auth.vue'),
			children: [
				{
					path: '',
					redirect: {name: 'login'},
				},
				{
					path: 'login',
					name: 'login',
					component: () => import('./views/Auth/Login.vue')
				},
				{
					path: 'registration',
					name: 'registration',
					component: () => import('./views/Auth/Registration.vue')
				}
			]
		},
		{
			path: '/customer-area',
			component: () => import('./views/CustomerArea/CustomerArea.vue'),
			meta: {requiresAuth: true},
			children: [
				{
					path: '',
					redirect: {name: 'account'},
				},
				{
					path: 'remote-control/',
					name: 'remote-control-machines',
					component: () => import('./views/CustomerArea/RemoteControl/Machines.vue')
				},
				{
					path: 'remote-control/:id',
					name: 'remote-control',
					meta: {layout: 'fullscreen'},
					component: () => import('./views/CustomerArea/RemoteControl/RemoteControl.vue')
				},
				{
					path: 'machines',
					name: 'machines',
					component: () => import('./views/CustomerArea/Machines/Machines.vue')
				},
				{
					name: 'machines-settings',
					path: 'machines-settings',
					redirect: {name: 'machines', query: {target: 'machine-settings'}},
				},
				{
					name: 'machines-remote-control',
					path: 'machines-remote-control',
					redirect: {name: 'machines', query: {target: 'machine-remote-control'}},
				},
				{
					name: 'machines-documents',
					path: 'machines-documents',
					redirect: {name: 'machines', query: {target: 'machine-documents'}},
				},
				{
					path: 'machines/:id',
					component: () => import('./views/CustomerArea/Machines/Machine.vue'),
					children: [
						{
							path: '',
							name: 'machine',
							redirect: {name: 'machine-settings'},
						},
						{
							path: 'settings',
							name: 'machine-settings',
							component: () => import('./views/CustomerArea/Machines/Settings.vue')
						},
						{
							path: 'remote-control',
							name: 'machine-remote-control',
							component: () => import('./views/CustomerArea/Machines/RemoteControl.vue')
						},
						{
							path: 'documents',
							name: 'machine-documents',
							component: () => import('./views/CustomerArea/Machines/Documents.vue')
						},
					]
				},
				{
					path: 'production-control',
					name: 'production-control',
					redirect: {name: 'coming-soon'},
				},
				{
					path: 'account',
					name: 'account',
					component: () => import('./views/CustomerArea/Account.vue'),
				},
			]
		}
	]
});

// beforeResolve perchè a differenza di beforeEach mi permette di chiamare anche i guard nei child
router.beforeResolve(async (to, from, next) => {
	// NProgress.start();
	if (to.matched.some(record => record.meta.requiresAuth)) {
		// this route requires auth, check if logged in
		// if not, redirect to login page.
		if (store.getters.isConnectionError) {
			try {
				let token = await Vue.storage.getItem('customer-token');
				await Vue.utils.autoLogin(token);
				if (store.getters.isConnectionError) {
					store.dispatch('setConnectionError', {connectionError: false});
				}
			} catch(e) {
				// next(false);
				next({
					name: 'home'
				});
				return;
			}

		}
		if (!store.getters.isAuthenticated) {
			next({
				name: 'login',
				query: {redirect: to.fullPath}
			});
			return;
		}
	}

	next(); // make sure to always call next()!
	return;
});

router.afterEach((to, from) => {
	// Complete the animation of the route progress bar.
	// NProgress.done()
})
export default router;